import { initializeApp, getApps, getApp, type FirebaseOptions } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

// Centralized Firebase config (keep values in .env)
const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

const apiKey = firebaseConfig.apiKey;
export const firebaseEnabled = typeof apiKey === 'string' && apiKey.trim().length > 0;

let app: any | null = null;
let appCheckInited = false;

if (firebaseEnabled) {
  app = getApps().length ? getApp() : initializeApp(firebaseConfig);

  try {
    const siteKey = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY;
    if (siteKey && typeof window !== 'undefined') {
      initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(siteKey),
        isTokenAutoRefreshEnabled: true,
      });
      appCheckInited = true;
    }
  } catch (e) {
    // Keep this visible — a silent no-op here previously let App Check stay
    // broken, undetected, for a very long time.
    // eslint-disable-next-line no-console
    console.warn('App Check init failed:', e);
  }
}

export const firebaseAppCheckEnabled = appCheckInited;
export const auth = firebaseEnabled ? getAuth(app) : null as any;
export const db = firebaseEnabled ? getFirestore(app) : null as any;
export const functions = firebaseEnabled ? getFunctions(app) : null as any;

// If running locally against the Firebase Emulator Suite, enable emulator connectors
if (typeof window !== 'undefined' && process.env.REACT_APP_USE_FIREBASE_EMULATOR === '1' && firebaseEnabled) {
  try {
    // Use require to avoid bundling emulator code in production builds
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { connectFunctionsEmulator } = require('firebase/functions');
    const functionsPort = Number(process.env.REACT_APP_FIREBASE_FUNCTIONS_PORT || 5001);
    connectFunctionsEmulator(functions, 'localhost', functionsPort);
  } catch (e) {
    // no-op: in case emulator helper is unavailable in this environment
  }
}
